import * as React from "react";

export type MoveFn = (from: number, to: number) => void;

export type DragListContextValue = {
  id: string;
  move: MoveFn;
  lastMoved?: number;
  length: number;
};

export const DragListContext = React.createContext<DragListContextValue>({
  id: "",
  move: () => {},
  length: 0,
});

export type DragListItemContextValue = {
  data: { index: number; listId: string };
  dragOverEdge: "top" | "bottom" | null;
  isDragging: boolean;
  setIsDragging: (isDragging: boolean) => void;
};

export const DragListItemContext =
  React.createContext<DragListItemContextValue>({
    data: { index: NaN, listId: "" },
    dragOverEdge: null,
    isDragging: false,
    setIsDragging: () => {},
  });

export const isDragListItemData = (
  data: Record<string, unknown>,
): data is { index: number; listId: string } => {
  return typeof data.index === "number" && typeof data.listId === "string";
};

export type DragListItemState = {
  dragOverEdge: "top" | "bottom" | null;
  isDragging: boolean;
  isLastMoved: boolean;
};

export const useDragListItemState = (): DragListItemState => {
  const { lastMoved } = React.useContext(DragListContext);
  const { data, isDragging, dragOverEdge } =
    React.useContext(DragListItemContext);
  return {
    dragOverEdge,
    isDragging,
    isLastMoved: lastMoved === data.index,
  };
};
